import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './styles.css';

interface IMessageImagesThreeImagesGridLayoutProps {
  images: React.ReactElement[];
  isReverseOrder: boolean;
}

/**
 * Компонент верстки галереи из нескольких фото (до 3 фото в группу)
 */
export const MessageImagesThreeImagesGridLayout: React.VFC<IMessageImagesThreeImagesGridLayoutProps> = ({
  images,
  isReverseOrder,
}) => {
  const items = React.useMemo(
    () =>
      images.map((image, index) => (
        <div key={index} className={styles['image']}>
          {image}
        </div>
      )),
    [images],
  );

  return (
    <div
      data-testid="message_images_grid"
      {...mergeStyles(styles['gallery'], isReverseOrder && styles[`gallery--reverse`])}
    >
      {items}
    </div>
  );
};
